import React, { useState } from 'react';
import Pagination from '../Pagination'; // Import the Pagination component
import CityPreview from './CityPreview';

const CitiesGrid = ({ cities }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 12;
  const totalPages = Math.ceil(cities.length / itemsPerPage);

  const handlePageChange = (newPage) => {
    if (newPage > 0 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  const paginatedCities = cities.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

  return (
    <div>
      <div className='grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6 mb-12'>
        {paginatedCities.map((city, index) => (
          <CityPreview key={index} city={city} />
        ))}
      </div>

      <Pagination // Use the Pagination component
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={handlePageChange}
      />
    </div>
  );
};

export default CitiesGrid;
